<div
  class="kros-modal-shell__focus-trap"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="allowFocusAutocapture"
>
  @if (template) {
    <ng-container *ngTemplateOutlet="template; context: templateContext" />
  } @else if (component) {
    <ng-container *ngComponentOutlet="component; inputs: contentInputs?.()" />
  }
</div>
